import { useSyncExternalStore } from 'react'

const subscribe = (onChange: () => void) => {
  document.addEventListener('visibilitychange', onChange)
  return () => document.removeEventListener('visibilitychange', onChange)
}

const isPageVisible = () => document.visibilityState === 'visible'

// False while the tab is in the background, minimized, or its window is covered.
// The browser stops drawing a hidden page, so animations and on-screen checks pause.
export const usePageVisible = () =>
  useSyncExternalStore(subscribe, isPageVisible)
